import { jsx } from 'react/jsx-runtime';
import { SelectionSetInput, SelectionSetLabel, ColorSwatch } from '@vp/swan';

const TemplateTileColorSwatch = (props) => {
  const { accessibleText, primaryColor, secondaryColor, value } = props;
  return /* @__PURE__ */ jsx(SelectionSetInput, { value, children: /* @__PURE__ */ jsx(SelectionSetLabel, { children: /* @__PURE__ */ jsx(ColorSwatch, { accessibleText, primaryColor, secondaryColor }) }) });
};

export { TemplateTileColorSwatch };
